var path = '/var/www/mmscny-cms/src/app/common/components/search-box/search-box.html';
var html = "<form> <div class=\"search-input form-group\"> <input type=search name=search ng-model=$ctrl.searchKey ng-change=$ctrl._onSearch() id=search placeholder={{$ctrl.placeholder}} empty-text-validation> <input type=image src=/./images/search-icon.png class=search-button alt=Submit> </div> </form>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/search-box/search-box.html
// module id = 742
// module chunks = 0